import { JobsWidget } from './widget.js'

window.JobsWidget = JobsWidget